(function () {
  'use strict';
  function initializeOffers() {
  var initialRadio = document.querySelector('[data-ee-v3-offers] input[type="radio"]:checked');
  var initialSize = initialRadio ? initialRadio.value : '3';
  document.querySelectorAll('[data-ee-v3-offers]').forEach(function (root) {
  if (root.dataset.eeV3Initialized) return;
  var product = root.closest('[data-comp="product"]');
  if (!product) return;
  var config = window.EE_V3_CHECKOUT || {};
  var offers = {
    '1': { total: 35, retail: 80, servings: 30, gifts: 2 },
    '3': { total: 89, retail: 240, servings: 90, gifts: 4 },
    '6': { total: 159, retail: 480, servings: 180, gifts: 4 }
  };
  var selected = initialSize;
  var cta = product.querySelector('[data-ee-v3-checkout]');
  var once = root.querySelector('[data-ee-v3-buy-once]');
  var error = root.querySelector('[data-ee-v3-error]');
  var season = ['WINTER', 'SPRING', 'SUMMER', 'FALL'][Math.floor(((new Date().getMonth() + 1) % 12) / 3)];
  var seasonLabel = root.querySelector('[data-ee-v3-season]');
  if (seasonLabel) seasonLabel.textContent = season;
  // Digital gifts are included with one bag; physical gifts unlock with larger packages.
  root.querySelectorAll('[data-ee-v3-gift="frother"], [data-ee-v3-gift="scoop"]').forEach(function (gift) {
    var lock = root.querySelector('.ee-v3-gift-lock').cloneNode(true);
    lock.querySelector('.ee-v3-sr-only').textContent = ' — available with 3 or 6 bags';
    gift.appendChild(lock);
  });
  function money(value) { return '$' + value.toFixed(2); }
  function selectOffer(size) {
    selected = size;
    root.querySelectorAll('input[type="radio"]').forEach(function (radio) { radio.checked = radio.value === size; });
    var offer = offers[size];
    root.querySelector('[data-ee-v3-total]').textContent = money(offer.total);
    root.querySelector('[data-ee-v3-retail]').textContent = money(offer.retail);
    root.querySelector('[data-ee-v3-savings]').textContent = 'Save ' + money(offer.retail - offer.total);
    root.querySelectorAll('[data-ee-v3-gift]').forEach(function (gift) {
      var kind = gift.getAttribute('data-ee-v3-gift');
      gift.hidden = kind === 'digital' && size === '6';
      var locked = kind === 'physical' ? size !== '6' : (kind === 'frother' || kind === 'scoop') && size === '1';
      gift.classList.toggle('is-locked', locked);
      var lock = gift.querySelector('.ee-v3-gift-lock');
      if (lock) lock.hidden = !locked;
    });
    product.querySelectorAll('[data-ee-v3-heading]').forEach(function (heading) {
      heading.textContent = 'Get ' + offer.servings + ' Servings of Cacao Bliss & ' + (offer.gifts ? offer.gifts + ' FREE Gifts' : 'FREE Shipping');
    });
    var refill = product.querySelector('[data-ee-v3-refill]');
    var refillText = (config[size] || {}).refillText || '';
    if (refill) {
      refill.textContent = refillText;
      refill.parentElement.hidden = !refillText;
      refill.parentElement.style.display = refillText ? '' : 'none';
    }
    error.hidden = true;
  }
  root.querySelectorAll('input[type="radio"]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      document.dispatchEvent(new CustomEvent('ee-v3-offer-change', { detail: radio.value }));
    });
  });
  document.addEventListener('ee-v3-offer-change', function (event) {
    if (offers[event.detail]) selectOffer(event.detail);
  });
  var deliveryDate = new Date();
  deliveryDate.setDate(deliveryDate.getDate() + 6);
  root.querySelector('[data-ee-v3-delivery]').textContent = deliveryDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  async function checkout(key) {
    var option = config[key];
    error.hidden = true;
    if (!option || !option.variantId || (key !== 'once' && !option.sellingPlanId)) {
      error.textContent = 'This offer is not available for checkout yet. Please check back soon.';
      error.hidden = false;
      return;
    }
    if (!window.EmptyCheckout) {
      error.textContent = 'Checkout could not load. Please refresh and try again.';
      error.hidden = false;
      return;
    }
    document.querySelectorAll('[data-ee-v3-checkout], [data-ee-v3-buy-once]').forEach(function (button) { button.disabled = true; });
    cta.setAttribute('aria-busy', 'true');
    try {
      var payload = { variantId: option.variantId, quantity: option.quantity || 1, giftVariantIds: option.giftVariantIds || [] };
      if (key !== 'once') payload.sellingPlanId = option.sellingPlanId;
      await window.EmptyCheckout.checkout(payload);
    } catch (failure) {
      error.textContent = failure.message || 'Something went wrong. Please try again.';
      error.hidden = false;
    } finally {
      document.querySelectorAll('[data-ee-v3-checkout], [data-ee-v3-buy-once]').forEach(function (button) { button.disabled = false; });
      cta.removeAttribute('aria-busy');
    }
  }
  cta.addEventListener('click', function () { checkout(selected); });
  once.addEventListener('click', function () { checkout('once'); });
  window.addEventListener('pageshow', function () {
    cta.disabled = once.disabled = false;
    cta.removeAttribute('aria-busy');
    var radio = root.querySelector('input[type="radio"]:checked');
    selectOffer(radio ? radio.value : selected);
  });
  selectOffer(selected);
  root.dataset.eeV3Initialized = 'true';

  var track = product.querySelector('[data-ee-v3-video-track]');
  var previous = product.querySelector('[data-ee-v3-video-prev]');
  var next = product.querySelector('[data-ee-v3-video-next]');
  function syncVideos() {
    previous.disabled = track.scrollLeft < 2;
    next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
  }
  function stepVideos(direction) {
    var card = track.firstElementChild;
    track.scrollBy({ left: direction * (card.getBoundingClientRect().width + 10), behavior: 'smooth' });
  }
  if (track) {
    previous.addEventListener('click', function () { stepVideos(-1); });
    next.addEventListener('click', function () { stepVideos(1); });
    track.addEventListener('scroll', syncVideos, { passive: true });
    window.addEventListener('resize', syncVideos);
    syncVideos();
    track.querySelectorAll('[data-ee-v3-video]').forEach(function (button) {
      button.addEventListener('click', function () {
        var source = (window.EE_TESTIMONIAL_VIDEOS || [])[Number(button.dataset.eeV3Video)];
        if (!source) return;
        track.querySelectorAll('video').forEach(function (video) { video.pause(); });
        var card = button.parentElement;
        var video = card.querySelector('video');
        if (!video) {
          video = document.createElement('video');
          video.src = source;
          video.poster = button.querySelector('img').src;
          video.controls = true;
          video.playsInline = true;
          video.preload = 'none';
          video.setAttribute('aria-label', button.getAttribute('aria-label'));
          card.appendChild(video);
          video.addEventListener('play', function () {
            track.querySelectorAll('video').forEach(function (other) { if (other !== video) other.pause(); });
          });
        }
        button.hidden = true;
        video.focus();
        var play = video.play();
        if (play && play.catch) play.catch(function () { video.controls = true; });
      });
    });
  }
  });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeOffers, { once: true });
  } else {
    initializeOffers();
  }
  document.addEventListener('shopify:section:load', initializeOffers);
})();
